import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddKeywordsSuccess({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Success'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

